import { render, staticRenderFns } from "./dialog-token.vue?vue&type=template&id=7c8bd103"
import script from "./dialog-token.vue?vue&type=script&lang=js"
export * from "./dialog-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports